const BASE_URL = 'https://adminapi.ajiji.com/api/v1/';
export default BASE_URL;